// extracted by mini-css-extract-plugin
export var button = "_nk-2";
export var card = "_nk-0";
export var closeButtonContainer = "_nk-3";
export var iconContainer = "_nk-1";